import { ca } from '@cian/analytics';

export const trackBookingPopupShow = () => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'booking',
    name: 'oldevent',
    label: 'confirmation_popup',
    useLastProducts: true,
  });
};
